import { definePlatformAPI, } from '../../common';
export const platformAPICreator = definePlatformAPI((superAPI) => {
    return (context) => {
        return {
            accessibility: Object.assign(Object.assign({}, superAPI.accessibility), { setAutoDomReorder: (enable) => superAPI.accessibility.setAutoDomReorder(context.appDefinitionId, enable), setSkipToContent: (enable) => superAPI.accessibility.setSkipToContent(context.appDefinitionId, enable), setVisualFocus: (enable) => superAPI.accessibility.setVisualFocus(context.appDefinitionId, enable) }),
        };
    };
});
//# sourceMappingURL=accessibility.internal.v2.js.map